import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./Pages/Home/Navbar";
import Home from "./Pages/Home/HomeScreen";
import ThankYou from "./Pages/Home/ThankYou";

import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: false, // Ensures animation runs only once
    });
  }, []);
  return (
    <div className="App">
      <Router>
        <>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="*" element={<div>404 Not Found</div>}></Route>
            <Route path="/thank-you" element={<ThankYou />}></Route>
          </Routes>
        </>
      </Router>
    </div>
  );
}

export default App;
